import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import { ApiStatus } from '../../types/api/status'
import { patent, patentType } from '../../types/slices/patentType'

const initialState: patentType =
{
    status: ApiStatus.FETCHED,
    patents: [],
    totalRows: 0,
    patentSelected: {} as patent,
    errorMessage: undefined,
    action: ''
}

const patentSlice = createSlice({
    name: 'patentSlice',
    initialState,
    reducers: {
        onFetchPatents(state, { payload }: { payload: patent[] }) {
            state.status = ApiStatus.FETCHED
            state.patents = payload
            state.errorMessage = undefined
        },
        onFetchTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
        onSetSelectedPatent(state, { payload }: { payload: patent }) {
            state.patentSelected = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        }
    }
})

export const selectPatentState = (state: RootState) => state.patentSlice
export default patentSlice.reducer
export const {
    onFetchPatents,
    onSetSelectedPatent,
    changeStatus,
    onFetchTotalRows
} = patentSlice.actions
